
import { Component, Vue, Prop } from 'vue-property-decorator';
import { LOAN_TAKE_BACK_MINIMUM_AMOUNT } from '@/loan/constants/loan-take-back-minimum-amount';
import { LoanDetails } from '@/loan/types/loan-details';
import { LoanFrequency } from '@/loan/enums/loan-frequency';
import { LoanStatus } from '@/loan/enums/loan-status';
import AmountChip from '@/core/components/AmountChip.vue';
import IconChip from '@/core/components/IconChip.vue';
import IconWithTooltip from '@/core/components/IconWithTooltip.vue';
import { LoanFI } from '@/loan/types/loan-fi';
import { UtilHelper } from '@/util/helper';

@Component({
	components: {
		AmountChip,
		IconChip,
		IconWithTooltip,
	},
})
export default class LoanSummaryMetaData extends Vue {
	@Prop({ required: true })
	public amountAvailableToTakeBack!: number;

	@Prop({ required: true })
	public amountDue!: number;

	@Prop({ required: true })
	public amountPastDue!: number;

	@Prop({ required: true })
	public autopayFrequency!: LoanFrequency;

	@Prop({ required: true })
	public autopayPaymentAmount!: number;

	@Prop({ required: true })
	public autopayTotalAmount!: number;

	@Prop({ required: true })
	public balance!: string;

	public formatDollar = UtilHelper.formatDollar;

	public formatPhone = UtilHelper.formatPhoneNumber;

	@Prop({ required: true })
	public interestRate!: number;

	@Prop({ required: true })
	public isAutopayOn!: boolean;

	@Prop({ required: true })
	public isMaxDaysPastDue!: boolean;

	@Prop({ required: true })
	public isPastDue!: boolean;

	@Prop({ required: true })
	public isTakeBackActive!: boolean;

	@Prop({ required: true })
	public isTakeBackEnabled!: boolean;

	@Prop({ required: true })
	public fi!: LoanFI;

	@Prop({ required: true })
	public loanId!: string;

	@Prop({ required: true })
	public loanDetails!: LoanDetails;

	@Prop({ required: true })
	public status!: LoanStatus;

	public takeBackMinimumText = `${UtilHelper.formatDollar(LOAN_TAKE_BACK_MINIMUM_AMOUNT)} Minimum`;

	get fiName(): string {
		return this.fi.name;
	}

	get fiPhone(): string {
		return this.fi.contactPhone;
	}

	get formattedInterestRate(): string {
		return `${(Number(this.interestRate) * 100).toFixed(3)}%`;
	}

	get isClosed(): boolean {
		return this.status === LoanStatus.CLOSED;
	}

	get isPastDueShown(): boolean {
		return this.isPastDue && this.amountPastDue > 0;
	}

	get isPaidOff(): boolean {
		return this.status === LoanStatus.PAID;
	}

	get lastStatusChangeDate(): string {
		return this.loanDetails.general.lastStatusChangeDate
			? UtilHelper.formatISOStringForDisplay(this.loanDetails.general.lastStatusChangeDate)
			: '';
	}

	get pastDueSinceDate(): string {
		return this.loanDetails.general.delinquentSinceDate
			? UtilHelper.formatISOStringForDisplay(this.loanDetails.general.delinquentSinceDate)
			: '';
	}

	get remainingDueDate(): string {
		return UtilHelper.formatISOStringForDisplay(this.loanDetails.general.paymentDueDate);
	}
}
